import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {filterFlowUnit} from '@src/utils'

interface ItemData {
    goodsReleaseId?: string
    goodsReleaseName?: string
    productOrderingTime?: string
    releasePrice?: string
    goodsType?: string
    activityId?: string
    actCode?: string
}

class HomeStore extends StoreExt {
    @observable bannerConfig: any // 广告banner
    @observable productList: string[] = [] // 可订购套餐列表 -
    @observable itemData: ItemData = {} //
    @observable refuelPackageOrderRecord: any = {} // 流量加油包订购记录列表
    @observable refuelPackageEndDate: any = '' // 流量加油包订购当前周期结束时间
    @observable refuelPackageList: string[] = [] // 流量加油包列表
    @observable lotteryInfo: any;

    // 抽奖活动信息
    @action
    getLotteryInfo = async () => {
        try {
            const res = await this.api.queryLuckDrawInfo({})
            runInAction(() => {
                this.lotteryInfo = res
            })
        } catch (e) {

        }
    }
    // 广告banner
    @action
    getBannerConfig = async () => {
        // 首页配置的module为1
        try {
            const res = await this.api.getContentConfig({
                contentModule: '4',
                type: '1'
            })
            runInAction(() => this.bannerConfig = res)
        } catch (e) {
        }
    }

    // 全部可订购套餐列表
    @action
    getAllAvailProductList = async ({areaId = '', cargoType = '', areaCode = ''}) => {
        const query = {areaId: areaId, cargoType: cargoType, areaCode: areaCode}
        const res = await this.api.getAvailProductData(query).catch(e => runInAction(() => this.productList = []))
        runInAction(() => {
            this.productList = res
        })
    }

    // 当月流量加油包订购记录
    @action
    getRefuelPackageOrderRecord = async () => {
        try {
            const res = await this.api.getRefuelPackageOrderRecord({})
            const obj = {}
            let endDate = ''
            res.map(item => {
                const policyDegree = filterFlowUnit(item.policyDegree)
                if (obj[policyDegree]) {
                    obj[policyDegree] = obj[policyDegree] + 1
                } else {
                    obj[policyDegree] = 1
                }
            })
            if (res instanceof Array && res.length > 0) {
                endDate = res[0].endDate
            }
            runInAction(() => {
                this.refuelPackageOrderRecord = obj
                this.refuelPackageEndDate = endDate
            })
        } catch (error) {
            console.error(error)
        }
    }

    // 流量加油包列表
    @action
    getRefuelPackage = async ({cargoType = '', areaCode = ''}) => {
        const param = {
            cargoType: cargoType,
            areaCode: areaCode
        }
        try {
            const res = await this.api.queryRefuelPackage(param);
            runInAction(() => {
                this.refuelPackageList = res
            })
        } catch (error) {
            console.log(error)
        }
    }

}

const homeStore = new HomeStore()
export {homeStore, HomeStore}
